import dynamic from 'next/dynamic'
import React from 'react'
import { useHotkeys } from 'react-hotkeys-hook'

import { css } from '@portal/styled-system/css'

import { useToggle } from '@/shared/lib/hooks'

const DebugPanel = dynamic(() => import('./view').then((module) => module.DebugDialog))

export function DebugOverlay({ enable, children }: React.PropsWithChildren<{ enable?: boolean }>) {
    if (!enable) {
        return <React.Fragment>{children}</React.Fragment>
    }

    return <DebugContainer>{children}</DebugContainer>
}

function DebugContainer({ children }: React.PropsWithChildren) {
    const [showDebugPanel, toggleDebugPanel] = useToggle(false)

    useHotkeys('meta+Slash, meta+Backslash', () => {
        toggleDebugPanel()
    })

    return (
        <div className={css({ display: 'flex' })}>
            <div className={css({ flex: 'auto', width: 'full' })}>{children}</div>

            {showDebugPanel && <DebugPanel onClose={toggleDebugPanel} />}
        </div>
    )
}
